let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "充电桩编号",
    props: "pileCode",
    minWidth: 200
  },
  {
    label: "型号名称",
    props: "",
    minWidth: 300,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      return row.pileTypeCode + "-" + row.pileTypeName;
    }
  },
  {
    label: "所属充电网点",
    props: "stationName",
    minWidth: 200
  },
  {
    label: "充电桩状态",
    props: "pileStatusDetailName",
    minWidth: 320,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.pileStatusDetailCode == 22 || row.pileStatusDetailCode == 15) {
        return `<span data-v-2edbd7e3="" class="el-tag el-tag--danger el-tag--light">${row.pileStatusDetailName +
          "：" +
          row.remark}</span>`;
      } else if (row.pileStatusDetailCode == 11) {
        return `<span data-v-2edbd7e3="" class="el-tag el-tag--success el-tag--light">${row.pileStatusDetailName}</span>`;
      } else {
        return `<span data-v-2edbd7e3="" class="el-tag el-tag--light">${row.pileStatusDetailName}</span>`;
      }
    }
  },
  {
    label: "运维状态",
    props: "repairStatusName",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.repairStatus === "03") {
        return `<span style="color: #333">${row.repairStatusName}</span>`;
      } else if (row.repairStatus === "04") {
        return `<span style="color: blue">${row.repairStatusName}</span>`;
      } else if (row.repairStatus === "05") {
        return `<span style="color: red">${row.repairStatusName}</span>`;
      } else {
        return `<span style="color: #333">${row.repairStatusName}</span>`;
      }
    }
  },
  {
    label: "是否支持放电",
    props: "",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.dischargeSupport === "Y") {
        return "支持";
      } else if (row.dischargeSupport === "N") {
        return "不支持";
      } else {
        return "";
      }
    }
  },
  {
    label: "本月是否充电",
    props: "useStatusCode",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.useStatusCode === "01") {
        return "是";
      } else if (row.useStatusCode === "02") {
        return "否";
      } else {
        return "";
      }
    }
  },
  {
    label: "厂商标识",
    props: "manufactureMark",
    minWidth: 160
  },
  {
    label: "软件版本号",
    props: "softVersion",
    minWidth: 100
  },
  {
    label: "电流输出类型",
    props: "currentOutTypeName",
    minWidth: 200
  },
  {
    label: "ICCID",
    props: "iccid",
    minWidth: 180
  },
  {
    label: "物联网卡号",
    props: "msisdn",
    minWidth: 240
  },
  {
    label: "充电速度",
    props: "chargingSpeedName",
    minWidth: 200
  },
  {
    label: "接口类型",
    props: "interfaceTypeName",
    minWidth: 200
  },
  {
    label: "充电枪数量",
    props: "gunPortNum",
    minWidth: 200
  },
  {
    label: "创建者",
    props: "createdByName",
    minWidth: 200
  },
  {
    label: "创建时间",
    props: "createdWhen",
    minWidth: 200
  },
  {
    label: "更新者",
    props: "lastModifiedByName",
    minWidth: 200
  },
  {
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 200
  }
];

//充电记录列表项
pageConfig.chargeRecordColumns = [
  {
    label: "订单编号",
    props: "orderNo",
    minWidth: 200
  },
  {
    label: "充电桩编号",
    props: "pileCode",
    minWidth: 200
  },
  {
    label: "用户手机号",
    props: "custPhone",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "开始时间",
    props: "beginTime",
    minWidth: 320
  },
  {
    label: "结束时间",
    props: "endTime",
    minWidth: 200
  },
  {
    label: "充电时长（分）",
    props: "chargeMin",
    minWidth: 200
  },
  {
    label: "订单属性",
    props: "orderPropertyName",
    minWidth: 120
  },
  {
    label: "充电电量（kW·h）",
    props: "chargeVal",
    minWidth: 200
  },
  {
    label: "订单金额（元）",
    props: "tActFee",
    minWidth: 180
  }
];

//抢修列表项
pageConfig.repairColumns = [
  {
    label: "充电桩编号",
    props: "pileCode",
    minWidth: 200
  },
  {
    label: "维修工单",
    props: "repairNo",
    minWidth: 200
  },
  {
    label: "所属站点",
    props: "stationName",
    minWidth: 320
  },
  {
    label: "维修状态",
    props: "repairStatus",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.repairStatus == "01") {
        return "未维修";
      } else {
        return "已维修";
      }
    }
  },
  {
    label: "维修结果",
    props: "repairResult",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.repairResult == "01") {
        return "未修复";
      } else {
        return "已修复";
      }
    }
  },
  {
    label: "申请日期",
    props: "applyTime",
    minWidth: 200
  },
  {
    label: "维修天数",
    props: "repairDateNum",
    minWidth: 200
  },
  {
    label: "申请原因",
    props: "applyReason",
    minWidth: 120
  },
  {
    label: "维修回执",
    props: "corpReturn",
    minWidth: 200
  },
  {
    label: "维修人",
    props: "repairPerson",
    minWidth: 180
  }
];

//故障记录列表项
pageConfig.faultRecordColumns = [
  {
    label: "充电桩编码",
    props: "rcsCode",
    minWidth: 200
  },
  {
    label: "故障时间",
    props: "createdWhen",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "故障描述",
    props: "pileStatusName",
    minWidth: 320
  },
  {
    label: "故障备注",
    props: "remark",
    minWidth: 200
  }
];

// 运维备注列表项
pageConfig.operationColumns = [
  {
    label: "充电桩编码",
    props: "pileCode",
    minWidth: 160
  },
  {
    label: "运维状态",
    props: "statusName",
    minWidth: 130,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.status === "03") {
        return `<span style="color: #333">${row.statusName}</span>`;
      } else if (row.status === "04") {
        return `<span style="color: blue">${row.statusName}</span>`;
      } else if (row.status === "05") {
        return `<span style="color: red">${row.statusName}</span>`;
      } else {
        return `<span style="color: #333">${row.statusName}</span>`;
      }
    }
  },
  {
    label: "备注说明",
    props: "remark",
    minWidth: 360
  },
  {
    label: "操作时间",
    props: "lastModifiedWhen",
    minWidth: 180
  }
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "title",
    name: "充电桩管理"
  }
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100]
};

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileDetail"
};

// 路由
pageConfig.listRouter = "pileList";

pageConfig.reportDetailRouter = "pileReportDetail";

pageConfig.chargeDetailRouter = "pileChargeDetail";

pageConfig.repairListDetail = "repairListDetail";

pageConfig.faultDetail = "faultDetail";

pageConfig.operationDetail = "operationDetail"; // 运维备注 页面路由

//维修新增路由
pageConfig.repairAddRouter = "repairAddDetail";

//维修路由
pageConfig.repairRouter = "repairDetail";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "router",
    name: "充电桩管理",
    router: "pileList"
  },
  {
    type: "title",
    name: "充电桩详情"
  }
];

pageConfig.formRules = {
  pileCode: [{ required: true, message: "请输入IMEI号", trigger: "blur" }],
  pileTypeCode: [
    { required: true, message: "请选择充电桩型号名称", trigger: "change" }
  ],
  currentOutTypeName: [
    { required: true, message: "请选择电流输出类型", trigger: "change" }
  ],
  gunNum: [{ required: true, message: "请输入充电桩枪数", trigger: "blur" }],
  //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
  optType: [{ required: true, message: "请选择充电桩类型", trigger: "change" }],
  chargingSpeed: [
    { required: true, message: "请选择充电速度", trigger: "change" }
  ],
  interfaceTypeName: [
    { required: true, message: "请选择接口标准", trigger: "change" }
  ],
  applyReason: [{ required: true, message: "请填写申请原因", trigger: "blur" }],
  repairPerson: [{ required: true, message: "请填写维修人", trigger: "blur" }],
  repairStatus: [
    { required: true, message: "请选择维修状态", trigger: "change" }
  ],
  repairResult: [
    { required: true, message: "请选择维修结果", trigger: "change" }
  ],
  repairDateNum: [
    { required: true, message: "请填写维修时间", trigger: "blur" }
  ],
  corpReturn: [{ required: true, message: "请填写运营商回执", trigger: "blur" }]
};

export default pageConfig;
